export { default as reducer } from './reducers';
export { STATE_NAME } from './constants';
export { default as Variant } from './components/Variant';
export { default as Experiment } from './containers/Experiment';
export { Experiment as ExperimentType } from './utils/getSelectedVariant';
export { getSelectedVariant } from './selectors';
export { initExperiments, playExperiment } from './actions';
